import script from "./SiteHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiteHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SiteHeader.vue?vue&type=style&index=0&id=2b3d38e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b3d38e2"]])

export default __exports__